import type { TrackerState, User } from "../types";

export async function getCurrentUser(): Promise<User | null> {
  try {
    const res = await fetch("/.auth/me");
    if (!res.ok) return null;
    const data = await res.json();
    return data.clientPrincipal ?? null;
  } catch {
    return null;
  }
}

export async function fetchState(): Promise<TrackerState> {
  const res = await fetch("/api/state");
  if (!res.ok) throw new Error(`GET /api/state failed: ${res.status}`);
  return res.json();
}

export async function saveState(state: TrackerState): Promise<void> {
  const { weekOf, keyChanges, escalations, workstreams } = state;
  const res = await fetch("/api/state", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ weekOf, keyChanges, escalations, workstreams }),
  });
  if (!res.ok) throw new Error(`PUT /api/state failed: ${res.status}`);
}
